import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ParticipantCashTransferServiceService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-settlement-services';

const usePostRequestParticipantCashTransfer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        ParticipantCashTransferServiceService.postApiAwardSettlementApiAppParticipantCashTransferServiceRequestCashTransfer(
          payload
        )
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message='Participant Cash Transfer Requested.' />
          );
          closeModal();
          await queryClient.invalidateQueries('getParticipantCashTransferList');
          await queryClient.invalidateQueries('getCurrentBalanceForParticipants');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostRequestParticipantCashTransfer;
